module.exports = __webpack_public_path__ + "img/partner-12.6dc41242.png";